var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", [_c("el-row", {
    attrs: {
      gutter: 5
    }
  }, [_c("el-col", {
    attrs: {
      span: 15
    }
  }, [_c("role-apps-list")], 1), _c("el-col", {
    attrs: {
      span: 2
    }
  }, [_c("el-button", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showAdd,
      expression: "showAdd"
    }],
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.addApp
    }
  }, [_vm._v("新增渠道")])], 1)], 1)], 1), _c("el-tabs", {
    attrs: {
      value: "isBaseConfig"
    },
    on: {
      "tab-click": _vm.handleClick
    }
  }, [_c("el-tab-pane", {
    key: "first",
    attrs: {
      label: "渠道基础配置",
      name: "isBaseConfig"
    }
  }, [_vm.isBaseConfig ? _c("app-base-config") : _vm._e()], 1), _c("el-tab-pane", {
    key: "second",
    attrs: {
      label: "中心基本配置",
      name: "isGameCenterConfig"
    }
  }, [_vm.isGameCenterConfig ? _c("game-center-config") : _vm._e()], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };